import AccountingDashboardStore from "./AccountingDashboard.Store";
import PlantOverviewStore from "../../operations/PlantOverview/PlantOverview.Store";
import { RootStore } from "stores/index";
import { RouteType } from "types/RouteType";

const dashboardRoute: RouteType = {
  name: "Accounting Dashboard",
  path: "/accounting/dashboard",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Accounting Dashboard",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./AccountingDashboard.Header"),
    },
    body: {
      component: () => import("./AccountingDashboard.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  // permissionPath: "accounting.dashboard",
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const accountingDashboardStore =
      rootStore.accountingDashboardStore as AccountingDashboardStore;
    const plantOverviewStore =
      rootStore.plantOverviewStore as PlantOverviewStore;

    // Load both dashboard data and plant data in parallel
    await Promise.all([
      accountingDashboardStore.loadDashboardData(),
      plantOverviewStore?.initializePlants?.(),
    ]);

    return true;
  },
  dialogs: [
    {
      name: "AccountingDueDateDetail",
      title: "Due Date Details",
      component: () => import("./AccountingDashboard.Dialog"),
    },
  ],
};

export default dashboardRoute;
